import { RouterProvider, Outlet} from "react-router";

// Custom theme
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import customTheme from './custom-theme';

import './App.css';

// Components import
import Homepage        from "./components/Homepage/Homepage";
import OurTeam         from "./components/OurTeam";
import Participate     from "./components/Participate";
import Contact         from "./components/Contact";
import FAQ             from "./components/FAQ";
import Footer          from "./components/Footer/Footer";
import Header          from "./components/Header/Header";
import Login           from "./components/Login/Login";
import Video           from "./components/Video/Video";
import VideosAll       from './components/VideosAll/VideosAll';
import NavBar          from './components/NavBar/NavBar';
import SwitchLngs      from "./components/SwitchLngs/SwitchLangs";
import Error           from "./components/Error/Error";
import Dashboard       from "./components/Dashboard/Dashboard";
import SurveyTopics    from "./components/Survey/SurveyTopics";
import SurveyQuestion  from "./components/Survey/SurveyQuestion";
import SurveyResponses from "./components/Survey/SurveyResponses";
import ThankYou        from "./components/Survey/ThankYou";
import Portal          from "./components/Portal";
import VaccineInfo     from "./components/VaccineInfo";
import AddParticipant  from "./components/AddParticipant/AddParticipant";
import Success         from "./components/AddParticipant/Success";
import RequireAuth     from "./components/RequireAuth";
import RequireSurveyAccess from "./components/RequireSurveyAccess";
import ScrollToTop     from "./components/ScrollToTop";
import AuthErrorBanner from "./components/Error/AuthErrorBanner";
import AuthErrorReset  from "./components/Error/AuthErrorReset";
import CompletionModal  from "./components/CompletionModal";
import { AuthProvider } from "./components/AuthContext";
import { SurveyResponseProvider } from "./components/Survey/SurveyResponseContext";
import { AssignedVideosProvider } from "./components/AssignedVideosContext";
import { ActivitiesCompletionProvider } from "./components/ActivitiesCompletionContext";
import { sentryCreateBrowserRouter as createBrowserRouterWithSentry } from './instrument';

const AuthProtected = () => {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  )
}

const SurveyProtected = () => {
  return (
    <RequireSurveyAccess>
      <Outlet />
    </RequireSurveyAccess>
  )
}

const router = createBrowserRouterWithSentry([
  {
    path: "/",
    element: (
      <>
        <Header />
        <NavBar />
        <SwitchLngs />
        <main>
          <AuthErrorReset />
          <AuthErrorBanner />
          <ScrollToTop />
          <Outlet />
        </main>
        <Footer />
      </>
    ),
    children: [
      {path: "/",            element: <Homepage />   },
      {path: "/login",       element: <Login />      },
      {path: "/team",        element: <OurTeam />    },
      {path: "/participate", element: <Participate />},
      {path: "/faq",         element: <FAQ />        },
      {path: "/contact",     element: <Contact />    },
      {
        element: <AuthProtected />,
        children: [
          {path: "/videos",           element: <VideosAll />      },
          {path: "/videos/:id",       element: <Video />          },
          {path: "/dashboard",        element: <Dashboard />      },
          {path: "/portal",           element: <Portal />         },
          {path: "/vaccine-info",     element: <VaccineInfo />    },
          {
            element: <SurveyProtected />,
            children: [
              {path: "/survey",           element: <SurveyTopics />   },
              {path: "/survey/question",  element: <SurveyQuestion /> },
              {path: "/survey/submitted", element: <ThankYou />       },
            ]
          },
          {path: "/survey/responses", element: <SurveyResponses />},
          {path: "/new-participant",  element: <AddParticipant /> },
          {path: "/new-participant/success", element: <Success /> },
        ]
      },
      {path: "*", element: <Error message="Page not found." />},
    ],
    errorElement: <Error />,
  },
]);



export default function App() {

  return (
    <AuthProvider>
      <AssignedVideosProvider>
        <SurveyResponseProvider>
          <ActivitiesCompletionProvider>
            <ThemeProvider theme={customTheme}>
              <CssBaseline />
              <CompletionModal />
              <RouterProvider router={router} />
            </ThemeProvider>
          </ActivitiesCompletionProvider>
        </SurveyResponseProvider>
      </AssignedVideosProvider>
    </AuthProvider>
  );
}